import { AppNode, GroupNode } from "@features/builder/graph/types"
import {
  groupPadding as GROUP_PADDING,
  groupTitleHeight as GROUP_TITLE_HEIGHT,
} from "@features/builder/helpers/nodes"
import { InternalNode } from "@xyflow/react"

export function getNodePositionInsideGroup(
  nodeToMove: AppNode,
  groupNode: InternalNode<GroupNode>,
  groupPadding: number = GROUP_PADDING,
  groupTitleHeight: number = GROUP_TITLE_HEIGHT,
): { x: number; y: number } {
  const nodeWidth = Number(nodeToMove.measured?.width)
  const nodeHeight = Number(nodeToMove.measured?.height)
  const groupWidth = Number(groupNode.measured?.width)
  const groupHeight = Number(groupNode.measured?.height)

  const fence = {
    left: groupPadding,
    right: groupWidth - nodeWidth - groupPadding,
    top: groupPadding + groupTitleHeight,
    bottom: groupHeight - nodeHeight - groupPadding,
  }

  let x = structuredClone(nodeToMove.position.x)
  let y = structuredClone(nodeToMove.position.y)

  if (x < fence.left) x = fence.left
  if (x > fence.right) x = fence.right
  if (y < fence.top) y = fence.top
  if (y > fence.bottom) y = fence.bottom

  return { x, y }
}
